import React from 'react';
import { Cloud, HardDrive, AlertTriangle, Check, X } from 'lucide-react';

export type StatusType = 'synced' | 'pending' | 'conflict' | 'active' | 'inactive';

interface StatusBadgeProps {
  status: StatusType;
  label?: string;
  size?: 'sm' | 'md';
}

export function StatusBadge({ status, label, size = 'sm' }: StatusBadgeProps) {
  const configs = {
    synced: {
      color: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20',
      icon: Cloud,
      defaultLabel: 'Guardado en la nube',
    },
    pending: {
      color: 'bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20',
      icon: HardDrive,
      defaultLabel: 'Guardado en este equipo',
    },
    conflict: {
      color: 'bg-red-500/10 text-red-600 dark:text-red-400 border-red-500/20',
      icon: AlertTriangle,
      defaultLabel: 'Conflicto de sincronización',
    },
    active: {
      color: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20',
      icon: Check,
      defaultLabel: 'Activo',
    },
    inactive: {
      color: 'bg-slate-500/10 text-slate-500 dark:text-slate-400 border-slate-500/20',
      icon: X,
      defaultLabel: 'Inactivo',
    },
  }[status];

  const Icon = configs.icon;
  const displayText = label || configs.defaultLabel;
  const sizeClasses = size === 'sm' ? 'px-2.5 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span
      className={`inline-flex items-center gap-1.5 font-semibold rounded-full border ${configs.color} ${sizeClasses}`}
    >
      <Icon className="h-3.5 w-3.5 shrink-0" />
      <span>{displayText}</span>
    </span>
  );
}
